import { html, customElement } from '@adobe/edex/ui/edex-lit';
import '@spectrum-web-components/dialog/sp-dialog-wrapper.js';
import styles from '@adobe/edex/ui/components/shared/dialog/dialog.lit.scss';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { BaseElement } from '@adobe/edex/ui/components/base.element';

@customElement(EdexTagName.dialog)
export class Dialog extends BaseElement {
  static styles = styles;
  static get properties() {
    return {
      open: { type: Boolean },
      dismissable: { type: Boolean },
      header: { type: String },
      divider: { type: Boolean },
    };
  }
  open = false;
  dismissable = true;
  divider = false;
  header: string;

  firstUpdated() {
    setTimeout(this.fixWidthHeight);
  }

  // Changes applied to sp-dialog that are inaccessible in CSS
  fixWidthHeight = () => {
    const dialog = this.shadowRoot.querySelector('sp-dialog-wrapper').shadowRoot.querySelector('sp-dialog');
    if (!dialog) {
      return;
    }

    if (!this.header) {
      dialog.shadowRoot.querySelector<HTMLElement>('.grid').style.gridTemplateRows =
        'auto var(--spectrum-dialog-confirm-padding) 0 auto 1fr auto var(--spectrum-dialog-confirm-padding)';
    }
  };

  render() {
    const { header, dismissable, open, divider } = this;
    return html`
      <sp-dialog-wrapper
        headline="${$t(header)}"
        underlay
        ?hidden=${!open}
        ?open=${open}
        ?dismissable=${dismissable}
        ?no-divider=${!divider}
        ?responsive=${true}
        @close=${() => this.emitEvent('close')}
      >
        <div class="container">
          <slot name="content"></slot>
          <slot name="footer"></slot>
        </div>
      </sp-dialog-wrapper>
    `;
  }
}
